// @flow

import styled from 'styled-components';

import FixedLogo from '../common/components/ui/FixedLogo';

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #0085ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  text-align: center;
`;

const Text = styled.span`
  font-family: 'Open sans';
  font-weight: bold;
  font-size: 32px;
  color: #ffffff;
`;

export default function IEBlockedScreen() {
  return (
    <Container>
      <FixedLogo
        isUserLoggedIn={false}
        screen={null}
        screenWidth={window.innerWidth}
        kioskSessionId={0}
      />
      <Text>You are using an unsupported browser.</Text>
      <Text>Please consider trying Chrome, Safari or Firefox to use Sling.</Text>
    </Container>
  );
}
